import React from 'react'
import { useStoreConfig } from 'config'
import { getCanonical, getFileExtension } from '../util'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import { DefaultOGImage } from '@components/seo/src/ImagePath'

export type FutureOfHookahPageProps = {
    pathname: string
}

export const FutureOfHookah = ({
    pathname
}: FutureOfHookahPageProps): JSX.Element => {
    const config = useStoreConfig()
    const { seo, base } = config
    const { t } = useTranslation()

    const title = t('OOKA - Pod-Based Shisha Experience - The Future of Hookah')
    const description = t(
        'Elevate your gatherings with OOKA, the innovative charcoal-free hookah. Enjoy cleaner, faster, and more versatile hookah sessions. Be the first to experience OOKA.'
    )

    const ogImageAlt =
        seo?.default?.openGraph?.images &&
        seo?.default?.openGraph?.images[0]?.alt
    const ogImageContent = `${base.url.baseUrl}${DefaultOGImage}`

    return (
        <Head>
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={String(description)} />
            <link
                rel="canonical"
                href={getCanonical(pathname, base.url.baseUrl)}
            />
            {/* TWITTER */}
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta
                property="twitter:domain"
                content={seo.default.twitter?.handle}
            />
            <meta
                property="twitter:url"
                content={getCanonical(pathname, base.url.baseUrl)}
            />
            <meta name="twitter:card" content={seo.default.twitter?.cardType} />
            <meta name="twitter:image" content={ogImageContent} />
            {/* OPEN GRAPH */}
            <meta
                property="og:url"
                content={getCanonical(pathname, base.url.baseUrl)}
            />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImageContent} />
            <meta property="og:image:alt" content={ogImageAlt} />
            <meta
                property="og:image:type"
                content={`image/${getFileExtension(ogImageContent!)}`}
            />

            <meta property="og:site_name" content={seo.default.twitter?.site} />
        </Head>
    )
}
